import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { StaffExtendedDto, AllocationDto } from '@api/client';

interface StaffLike extends Partial<StaffExtendedDto> {
  extractedNominativo?: string;
  extractedProfessional?: string;
}

const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const exportTeamTableToExcel = (
  rows: StaffLike[],
  fileName = 'team-table',
) => {
  // Trova tutti i mesi presenti nelle allocazioni per costruire le colonne
  const monthKeys = new Map<string, { year: number; month: number }>();
  rows.forEach((row) => {
    (row.allocazioni || []).forEach((a: AllocationDto) => {
      if (a.year != null && a.month != null) {
        const key = `${a.year}-${String(a.month).padStart(2, '0')}`;
        if (!monthKeys.has(key)) monthKeys.set(key, { year: a.year, month: a.month });
      }
    });
  });
  const sortedMonths = Array.from(monthKeys.entries()).sort(([a], [b]) => a.localeCompare(b));

  const data = rows.map((row) => {
    const base: Record<string, string | number | undefined> = {
      Nominativo: row.extractedNominativo ?? row.name ?? row.userId ?? '',
      Profilo: row.extractedProfessional ?? row.idPps ?? '',
      Cost: row.cost,
    };
    sortedMonths.forEach(([, { year, month }]) => {
      const alloc = (row.allocazioni || []).find((a) => a.year === year && a.month === month);
      const label = `${MONTH_LABELS[month - 1]} ${year}`;
      base[label] = alloc?.actualAllocation ?? alloc?.extimatedAllocation ?? 0;
    });
    return base;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Team');
  const buf = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
};
